export const ValueInCurlyBraces = ({ value }: { value: string }) => <>{`{${value}}`}</>;

export const UnsupportedValueInCurlyBraces = ({ value }: { value: never }) => <ValueInCurlyBraces value={value} />;
